import type { SVGProps } from "react";
export interface DollarCircleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function DollarCircleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: DollarCircleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 0-17.75 0 8.875 8.875 0 0 0 17.75 0m2.25 0c0 6.144-4.98 11.124-11.124 11.125S.875 18.145.875 12 5.856.875 12.001.875c6.143 0 11.124 4.981 11.124 11.126Z"
      />
      <path
        fill={color}
        d="m10.313 9.35.02.205c.04.187.146.326.337.465.311.226.825.42 1.551.565 1.796.36 3.716 1.543 3.716 3.759 0 1.755-1.21 3.165-2.812 3.622V18a1.125 1.125 0 0 1-2.25 0v-.012a3.88 3.88 0 0 1-2.659-2.254l-.095-.254-.03-.11a1.124 1.124 0 0 1 2.123-.707l.041.107.08.193c.214.424.678.848 1.476.906l.189.005.185-.007c.9-.084 1.502-.783 1.502-1.523 0-.56-.45-1.19-1.656-1.496l-.252-.057c-.837-.167-1.73-.44-2.433-.952-.762-.554-1.284-1.382-1.284-2.489v-.012c.004-1.69 1.277-2.909 2.813-3.315V6a1.125 1.125 0 0 1 2.25 0v.012a3.88 3.88 0 0 1 2.659 2.253l.096.255.031.11a1.125 1.125 0 0 1-2.124.708l-.042-.107-.08-.194c-.231-.457-.751-.912-1.665-.912-1.139 0-1.687.727-1.688 1.22z"
      />
    </svg>
  );
}
